import React from "react"
import PropTypes from "prop-types"
import {Box, CircularProgress, Paper} from "@mui/material"
import DatePickerSelectV2 from "src/v2/components/Date/date-picker-select"
import TextFieldInput from "src/v2/components/Input/text-field-input"
import ButtonWithIcon from "src/v2/components/Button/Button"
import {ReactComponent as CalcIcon} from "src/v2/assets/icons/calc-icon.svg"
const PARAMETER_FIELD_MIN_HEIGHT = 72
const PARAMETER_FIELDS = [
    {field: "puparReferencia", label: "PUPAR Referência"},
    {field: "pumtmReferencia", label: "PUMTM Referência"},
    {field: "spreadCredito", label: "Spread Crédito"},
]

const ValidationParametersSection = ({
    parameters,
    referenceDateError = false,
    decimalErrors,
    onParameterChange,
    onReferenceDateChange,
    onCalculate,
    canCalculate,
    isCalculating = false,
}) => (
    <Paper
        component="section"
        elevation={0}
        aria-label="Parâmetros de cálculo"
        sx={{
            px: {xxxs: 2, md: 3},
            pt: {xxxs: 2, md: 3},
            pb: {xxxs: 0.5, md: 1.5},
            bgcolor: "background.paper",
            borderRadius: 0,
        }}
    >
        <Box
            sx={{
                display: "grid",
                gridTemplateColumns: {
                    xxxs: "minmax(0, 1fr)",
                    md: "repeat(2, minmax(0, 1fr))",
                    lg: "repeat(4, minmax(0, 1fr)) minmax(180px, 0.7fr)",
                },
                gap: 2,
                alignItems: "start",
            }}
        >
            <Box sx={{minWidth: 0, minHeight: PARAMETER_FIELD_MIN_HEIGHT}}>
                <DatePickerSelectV2
                    label="Data Referência"
                    size="sm"
                    value={parameters.dataReferencia}
                    onChange={onReferenceDateChange}
                    defaultToToday={false}
                    filledBackground="white05"
                    required
                    error={!parameters.dataReferencia}
                    helperText={!parameters.dataReferencia
                        ? referenceDateError
                            ? "Data padrão indisponível. Informe a data de referência manualmente."
                            : "Informe a data de referência."
                        : undefined}
                />
            </Box>

            {PARAMETER_FIELDS.map(({field, label}) => (
                <Box
                    key={field}
                    sx={{minWidth: 0, minHeight: PARAMETER_FIELD_MIN_HEIGHT}}
                >
                    <TextFieldInput
                        label={label}
                        fullWidth
                        value={parameters[field].replace(".", ",")}
                        onChange={onParameterChange(field)}
                        error={Boolean(decimalErrors[field])}
                        helperText={decimalErrors[field]}
                        inputProps={{inputMode: "decimal"}}
                    />
                </Box>
            ))}

            <Box sx={{minWidth: 0, pt: 0.5}}>
                <ButtonWithIcon
                    size="md"
                    icon={isCalculating
                        ? <CircularProgress size={18} color="inherit" aria-hidden="true"/>
                        : <CalcIcon aria-hidden="true"/>}
                    disabled={!canCalculate}
                    onClick={canCalculate ? onCalculate : undefined}
                    aria-busy={isCalculating}
                    sx={{
                        width: "100%",
                        justifyContent: "center",
                    }}
                >
                    {isCalculating ? "CALCULANDO..." : "CALCULAR"}
                </ButtonWithIcon>
            </Box>
        </Box>
    </Paper>
)

ValidationParametersSection.propTypes = {
    parameters: PropTypes.shape({
        dataReferencia: PropTypes.string,
        puparReferencia: PropTypes.string,
        pumtmReferencia: PropTypes.string,
        spreadCredito: PropTypes.string,
    }).isRequired,
    referenceDateError: PropTypes.bool,
    decimalErrors: PropTypes.shape({
        puparReferencia: PropTypes.string,
        pumtmReferencia: PropTypes.string,
        spreadCredito: PropTypes.string,
    }).isRequired,
    onParameterChange: PropTypes.func.isRequired,
    onReferenceDateChange: PropTypes.func.isRequired,
    onCalculate: PropTypes.func,
    canCalculate: PropTypes.bool.isRequired,
    isCalculating: PropTypes.bool,
}

export default ValidationParametersSection
